import React from "react"
import classnames from "classnames"

export const SpinnerVariants = Object.freeze({
  Primary: "spinner-primary",
  White: "spinner-white",
})

export default function Spinner({
  className,
  variant = SpinnerVariants.Primary,
  ...props
}) {
  return (
    <div
      aria-label="Loading..."
      className={classnames("spinner", variant, className)}
      {...props}
    />
  )
}
